module.exports = __webpack_public_path__ + "img/login-icon.7672b9e3.svg";